import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import app from '../components/app/reducer'
import auth from '../pages/Auth/reducer'
import user from '../pages/User/reducer'
import settings from '../pages/settings/reducer'
import groups from '../pages/Groups/reducer'
import permissions from '../pages/Permissions/reducer'
import analytics from '../pages/Analytics/reducer'
import Screen1Reducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/screen1/reducer'
import Screen2Reducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/screen2/reducer'
import Screen3Reducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/screen3/reducer'
import Screen4Reducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/screen4/reducer'
import Screen5Reducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/screen5/reducer'
import Screen6Reducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/screen6/reducer'
import Screen7Reducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/screen7/reducer'
import ScreensCommonReducer from 'pages/Dashboard/HomeSevenScreen/7screen/redux/ScreensCommon/reducer'

export default (history) => {
    const rootReducer = combineReducers({
        app,
        auth,
        user,
        settings,
        analytics,
        router: connectRouter(history),
        Screen1Reducer,
        Screen2Reducer,
        Screen3Reducer,
        Screen4Reducer,
        Screen5Reducer,
        Screen6Reducer,
        Screen7Reducer,
        ScreensCommonReducer
    })

    return (state = {}, action) => {
        if (!action) return state

        // use the regular reducer
        return rootReducer(state, action)
    }
}
